import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex flex-row w-100 flex-wrap gap-3 px-3 py-3" }
const _hoisted_2 = {
  key: 0,
  class: "col-form-label contextLabel text-end"
}
const _hoisted_3 = {
  key: 1,
  class: "col-form-label contextLabel text-end"
}
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass('d-flex flex-row gap-3 ')
}
const _hoisted_5 = { class: "invalid-feedback" }
const _hoisted_6 = {
  key: 1,
  class: "d-flex flex-row gap-3"
}
const _hoisted_7 = { class: "invalid-feedback" }
const _hoisted_8 = {
  key: 2,
  class: "d-flex flex-row gap-3"
}
const _hoisted_9 = { class: "invalid-feedback" }
const _hoisted_10 = {
  key: 3,
  class: "d-flex flex-row gap-3"
}
const _hoisted_11 = { class: "invalid-feedback" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Label = _resolveComponent("Label")!
  const _component_CustomSelect = _resolveComponent("CustomSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (this.ctx.getNumberOfOrganisations() > 1 && _ctx.ctx.contextLevel >= _ctx.ContextLevel.NETWORK || this.ctx.activeOrgPersonHint)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (this.ctx.buekMode)
            ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.$t("contextLine.buekContextLineCaption")), 1))
            : (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(_ctx.$t("contextLine.contextLineCaption")), 1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Label, {
              class: _normalizeClass('text-end col-form-label ' + (this.ctx.activeOrgPersonHint ? 'orgPersonHint' : '')),
              for: _ctx.$id('organisationSelect')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('general.organisation')), 1)
              ]),
              _: 1
            }, 8, ["class", "for"]),
            _createElementVNode("div", null, [
              _createVNode(_component_CustomSelect, {
                mode: "flex",
                wasValidated: "",
                class: _normalizeClass('w-auto'),
                id: _ctx.$id('organisationSelect'),
                disabled: _ctx.disabledByRoute,
                required: "",
                options: this.organisationPersonOptions,
                modelValue: this.ctx.activeOrganisationPersonId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.ctx.activeOrganisationPersonId) = $event))
              }, null, 8, ["id", "disabled", "options", "modelValue"]),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('contextLine.missingOrganisationPerson')), 1)
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (!_ctx.invisibleByRoute && _ctx.ctx.contextLevel >= _ctx.ContextLevel.NETWORK)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_Label, {
            class: "text-end col-form-label",
            for: _ctx.$id('networkSelect')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('general.network')), 1)
            ]),
            _: 1
          }, 8, ["for"]),
          _createElementVNode("div", null, [
            _createVNode(_component_CustomSelect, {
              mode: "flex",
              wasValidated: "",
              class: "w-auto",
              id: _ctx.$id('networkSelect'),
              options: this.networkOptions,
              modelValue: this.ctx.activeNetworkId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.ctx.activeNetworkId) = $event)),
              required: _ctx.ctx.contextLevel >= _ctx.ContextLevel.NETWORK,
              disabled: _ctx.disabledByRoute || _ctx.effectiveContextLevel <= _ctx.ContextLevel.NONE
            }, null, 8, ["id", "options", "modelValue", "required", "disabled"]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('contextLine.missingNetwork')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.invisibleByRoute && _ctx.ctx.contextLevel >= _ctx.ContextLevel.PROJECT)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_Label, {
            class: "text-end col-form-label",
            for: _ctx.$id('projectSelect')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('general.project')), 1)
            ]),
            _: 1
          }, 8, ["for"]),
          _createElementVNode("div", null, [
            _createVNode(_component_CustomSelect, {
              mode: "flex",
              wasValidated: "",
              class: "w-auto",
              id: _ctx.$id('projectSelect'),
              options: this.projectOptions,
              modelValue: this.ctx.activeProjectId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.ctx.activeProjectId) = $event)),
              required: _ctx.ctx.contextLevel >= _ctx.ContextLevel.PROJECT,
              disabled: _ctx.disabledByRoute || _ctx.effectiveContextLevel <= _ctx.ContextLevel.NETWORK
            }, null, 8, ["id", "options", "modelValue", "required", "disabled"]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('contextLine.missingProject')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.invisibleByRoute && _ctx.ctx.contextLevel >= _ctx.ContextLevel.SUB_PROJECT)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_Label, {
            class: "text-end col-form-label",
            for: _ctx.$id('subProjectSelect')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('general.subProject')), 1)
            ]),
            _: 1
          }, 8, ["for"]),
          _createElementVNode("div", null, [
            _createVNode(_component_CustomSelect, {
              mode: "flex",
              wasValidated: "",
              class: "w-auto",
              id: _ctx.$id('subProjectSelect'),
              options: this.subProjectOptions,
              modelValue: this.ctx.activeSubProjectId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.ctx.activeSubProjectId) = $event)),
              required: _ctx.ctx.contextLevel >= _ctx.ContextLevel.SUB_PROJECT,
              disabled: _ctx.disabledByRoute || _ctx.effectiveContextLevel <= _ctx.ContextLevel.PROJECT
            }, null, 8, ["id", "options", "modelValue", "required", "disabled"]),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('contextLine.missingSubProject')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}